import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const keepColors = {
  WebkitPrintColorAdjust: 'exact',
  printColorAdjust: 'exact',
} as const;

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    overflow: 'auto',
    maxHeight: 'calc(100vh - 200px)',
    minHeight: 300,
    '@media print': {
      overflow: 'visible',
      maxHeight: 'none',
      minHeight: 0,
      boxShadow: 'none',
    },
  },
  table: {
    tableLayout: 'fixed',
    minWidth: 900,
    borderCollapse: 'separate',
    borderSpacing: 0,
    '@media print': {
      minWidth: 0,
      width: '100%',
      '& tr': {
        breakInside: 'avoid',
        pageBreakInside: 'avoid',
      },
    },
  },
  headerCell: {
    position: 'sticky',
    top: 0,
    zIndex: 2,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    textAlign: 'center',
    borderRight: '1px solid #FFFFFF',
    borderBottom: '1px solid #FFFFFF',
    padding: theme.spacing(0.5),
    '@media print': {
      position: 'static',
      fontSize: '0.7rem',
      ...keepColors,
    },
  },
  hourHeaderCell: {
    width: 90,
  },
  roomHeaderCell: {
    width: 70,
  },
  hourCol: {
    width: 90,
    '@media print': {
      width: 50,
    },
  },
  roomCol: {
    width: 70,
    '@media print': {
      width: 58,
    },
  },
  hourCell: {
    textAlign: 'center',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    borderLeft: '1px solid #BFBFBF',
    borderRight: '1px solid #BFBFBF',
    borderBottom: '1px solid #BFBFBF',
    padding: theme.spacing(0.5),
  },
  hourCellContinues: {
    borderBottom: 'none',
    '@media print': {
      borderBottom: '1px solid #BFBFBF',
    },
  },
  hourRepeatText: {
    visibility: 'hidden',
    '@media print': {
      visibility: 'visible',
    },
  },
  roomCell: {
    textAlign: 'center',
    verticalAlign: 'middle',
    borderRight: '1px solid #BFBFBF',
    borderBottom: '1px solid #BFBFBF',
    padding: theme.spacing(0.5),
  },
  overCapacityRoomCell: {
    backgroundColor: '#FCE4E4',
    color: '#B00020',
    fontWeight: 'bold',
  },
  dayCell: {
    borderRight: '1px solid #BFBFBF',
    borderBottom: '1px solid #BFBFBF',
    padding: 2,
    verticalAlign: 'top',
  },
  emptyCell: {
    color: '#9E9E9E',
    fontSize: '0.75rem',
    textAlign: 'center',
    padding: theme.spacing(1),
  },
  sectionCard: {
    borderRadius: 2,
    padding: theme.spacing(0.5),
    textAlign: 'center',
    lineHeight: 1.25,
    '&:not(:last-child)': {
      marginBottom: 2,
    },
    '@media print': {
      padding: 2,
      ...keepColors,
    },
  },
  sectionNumber: {
    fontWeight: 'bold',
    fontSize: '0.8rem',
    '@media print': {
      fontSize: '0.62rem',
    },
  },
  sectionText: {
    fontSize: '0.75rem',
    '@media print': {
      fontSize: '0.58rem',
    },
  },
  blockSpacer: {
    height: 10,
    backgroundColor: '#F2F2F2',
    border: 'none',
    borderBottom: '1px solid #BFBFBF',
    padding: 0,
    '@media print': {
      ...keepColors,
    },
  },
  printTitleRow: {
    display: 'none',
    '@media print': {
      display: 'table-row',
    },
  },
  printTitleCell: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 'bold',
    fontSize: '0.95rem',
    textAlign: 'center',
    border: 'none',
    borderBottom: '1px solid #FFFFFF',
    padding: theme.spacing(0.5),
    ...keepColors,
  },
  noPrint: {
    '@media print': {
      display: 'none',
    },
  },
  emptyBlock: {
    '@media print': {
      display: 'none',
    },
  },
  printArea: {
    '@media print': {
      marginTop: 0,
      padding: '8mm',
    },
  },
}));

export const PRINT_PAGE_CSS = `
@media print {
  @page { size: A4 portrait; margin: 0; }
  html, body { background-color: #FFFFFF; margin: 0; }
}
`;

export default useStyles;
